import React from 'react';
import Layout from '../../components/Layout';
import HeadMessage from '../../components/Common/HeadMessage/HeadMessage';
import Breadcrumbs from '../../components/Breadcrumbs';
import ChromeBackground from './ChromeBackground';
import { breadcrumbSchema, canonicalUrl, SITE_URL } from '../../utils/seo';
import { isReleased } from '../../data/widgets/release';

/**
 * /how-to-change-chrome-background
 *
 * Информационный запрос с самым большим спросом из найденных:
 * «how to change background on chrome» — 6 600 в месяц при сложности 18,
 * рядом «wallpaper for chrome» 12 100 и «customize chrome background».
 * В выдаче нет ни одной нормальной статьи — YouTube, Pinterest, форумы.
 * @see docs/seo/research/README.md
 *
 * Как и /how-to-change-new-tab: сначала честный ответ средствами самого
 * Chrome, наше расширение — только там, где Chrome не умеет.
 */
function action() {
	const url = '/how-to-change-chrome-background';

	// Страница из очереди поэтапной публикации: до своей даты её нет.
	// @see src/data/widgets/release.js
	if (!isReleased(url)) {
		return undefined;
	}

	return {
		title: 'How to Change the Background on Chrome',
		description:
			'Change your Chrome background in a minute from the Customize Chrome panel. Plus why the button goes missing, dark mode, and GIF or video wallpaper.',
		chunks: ['chrome-background'],
		jsonLd: [
			{
				'@context': 'https://schema.org',
				'@type': 'WebPage',
				'@id': `${canonicalUrl(url)}#webpage`,
				url: canonicalUrl(url),
				name: 'How to change the background on Chrome',
				description:
					'Changing the Chrome new tab background with the built-in Customize Chrome panel, fixing a missing button, dark mode, and animated, video and rotating wallpapers.',
				isPartOf: { '@id': `${SITE_URL}/#website` },
			},
			breadcrumbSchema([
				{ name: 'Home', url: '/' },
				{ name: 'How to change the background on Chrome', url },
			]),
		],
		component: (
			<Layout>
				<Breadcrumbs
					items={[
						{ name: 'Home', url: '/' },
						{ name: 'Changing the Chrome background' },
					]}
				/>

				<HeadMessage variant="compact">
					<h1>How to change the background on Chrome</h1>
				</HeadMessage>

				<ChromeBackground />
			</Layout>
		),
	};
}

export default action;
